
// PATCH pinned views
// to be removed in 3-4 months released in feb 2024


import {NavigationSectionType} from "../../model2/navigation/@const";

export default function patchPinnedViews() {

    let needSave = false

    _.map(gd.session.pins.models,(pin)=>{
        const customView = pin.customViewId ? gd.session.customViews.get(pin.customViewId) : null
        if (!customView) return false;

        if (customView && pin.companyId === gd.companyId && customView.location !== 'my-work') {
            gd.user.settings.navigation.setViewLocation(customView.id, NavigationSectionType.HOME)
            needSave = true

            gd.session.pins.deletePinById(pin.id)
        }
    });

    if (needSave) {
        gd.user.settings.save()
    }

    // END patch


}